document.addEventListener("DOMContentLoaded", function () {
    var referrer = document.referrer;
    var referrerIsCollection = /\/collections\/.+/i.test(referrer);
    var collectionNameElement = document.getElementById("breadcrumb-collection-name");

    // Store the collection title when on a collection page
    var collectionTitleElement = document.querySelector(".collection-title-selector");
    if (collectionTitleElement) {
        sessionStorage.setItem("CollectionTitle", collectionTitleElement.textContent);
        sessionStorage.setItem("CollectionURL", window.location.href);
    }

    // Parsing the referrer URL
    var a = document.createElement("a");
    a.href = referrer;

    // Check if it's the same domain and it's the homepage
    var isHomePage = window.location.hostname === a.hostname && a.pathname === "/";

    if (collectionNameElement) {

            var lastCollectionTitle = document.getElementById("last-collection-title");
            var lastCollectionUrl = document.getElementById("last-collection-url");
            if (lastCollectionTitle && lastCollectionUrl) {
                collectionNameElement.textContent = lastCollectionTitle.value;
                collectionNameElement.href = lastCollectionUrl.value;
        } else {
            // Optionally hide the element if it's neither coming from a collection page nor homepage.
            document.getElementById("breadcrumb-container").style.display = "none";
        }
    }
});
